'use client'

import 'react-day-picker/dist/style.css'
import { DayPicker } from 'react-day-picker'
import type { PropsBase, PropsSingle } from 'react-day-picker'

import { cn } from '@/lib/utils'

type CalendarProps = Omit<PropsBase & PropsSingle, 'className'> & {
  className?: string
}

function Calendar({ className, ...props }: CalendarProps) {
  return (
    <div
      className={cn(
        'rounded-md border border-input bg-background p-2',
        className,
      )}
    >
      <DayPicker {...props} />
    </div>
  )
}

export { Calendar }
